export default "__VITE_ASSET__DbimR5b8__"